import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseParamsService } from '@app/core/base-params.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { ApiInjectSessionResponse, EmbedTokenResponse, SessionSignInData } from '@app/core/session/interfaces';
import { SessionApiProvider } from '@app/core/session/session-api-provider';

@Injectable()
export class SessionApiService implements SessionApiProvider {
  private http = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);


  public deprecatedSignIn(data: SessionSignInData): Observable<string> {
    return this.http.post<{ auth_token: string }>(
      this.sessionUrl(),
      {
        member: data,
      },
    ).pipe(
      map((json: { auth_token: string }) => json.auth_token),
    );
  }

  public signOut(): Observable<unknown> {
    return this.http.delete(
      this.sessionUrl(),
      { headers: this.baseParamsService.getAuthHeaders() },
    );
  }

  public getBasicAutologinInfo(): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(
      `${this.sessionUrl()}/basic_autologin_info`,
      { headers: this.baseParamsService.getAuthHeadersWithAutologin(false) || new HttpHeaders() },
    );
  }

  public authenticateBasically(): Observable<boolean> {
    return this.http.get<{ status: string }>(
      `${this.sessionUrl()}/authenticated_basically`,
      { headers: this.baseParamsService.getAuthHeaders() },
    ).pipe(
      map((json) => json.status === 'ok'),
      catchError(() => of(false)),
    );
  }

  public injectSession(token: string): Observable<ApiInjectSessionResponse> {
    return this.http.post<ApiInjectSessionResponse>(
      `${this.sessionUrl()}/inject`,
      { member_access_token: token },
    );
  }

  public getGamesEmbedToken(): Observable<string> {
    return this.http.get<EmbedTokenResponse>(
      `${this.sessionUrl()}/embed_token`,
      { headers: this.baseParamsService.getAuthHeaders() },
    ).pipe(
      map(({ token }: EmbedTokenResponse) => token),
    );
  }

  private getBaseUrl(): string {
    return `${environment.webforms_api}/v2/${this.currentSlug()}`;
  }

  private sessionUrl(): string {
    return `${this.getBaseUrl()}/sessions`;
  }

  private currentSlug(): string {
    return this.baseParamsService.slug;
  }
}
